import { AccountRoutes } from "./routes";

export const ACCOUNT_MENU_ITEM_IDS = {
  FNP_CASH: "fnp-cash",
  MY_ORDERS: "my-orders",
  SAVED_ADDRESSES: "saved-addresses",
  MY_PROFILE: "my-profile",
  GIFT_VOUCHERS: "gift-vouchers",
  NOTIFICATIONS: "notification-settings",
  PARTNERS: "partners",
  LOGOUT: "logout",
  PRIVACY: "privacy-policy",
};

/** Mobile account home list (legacy HOMEPAGE_LIST, without JSX). */
export const accountHomeMenuItems = [
  {
    id: ACCOUNT_MENU_ITEM_IDS.FNP_CASH,
    label: "FNP CASH",
    slug: AccountRoutes.WALLET_DETAILS,
    icon: "/assets/icons/fnpcash-grey.svg",
    subText: "Quick Checkout, Easy Refund",
    hideForSmartBuyOrCorporate: true,
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.MY_ORDERS,
    label: "MY ORDERS",
    slug: AccountRoutes.MY_ORDERS,
    icon: "/assets/icons/box.svg",
    subText: "Order related Issues, Track Order & download invoice",
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.SAVED_ADDRESSES,
    label: "SAVED ADDRESSES",
    slug: AccountRoutes.MY_ADDRESS_BOOK,
    icon: "/assets/icons/Location_icon-grey.svg",
    subText: "Save address for a hassle-free checkout",
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.PRIVACY,
    label: "PRIVACY POLICY",
    slug: "",
    href: "/info/privacy-policy",
    icon: "/assets/icons/document-text.svg",
    subText: "The security of your personal information is important to us",
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.NOTIFICATIONS,
    label: "NOTIFICATION SETTINGS",
    slug: AccountRoutes.NOTIFICATION_SETTING,
    icon: "/assets/icons/notification-grey.svg",
    subText: "Manage your notification preferences",
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.PARTNERS,
    label: "PARTNERS",
    slug: AccountRoutes.PARTNERS,
    icon: "/assets/icons/users.svg",
    subText: "Earn rewards with every FNP order!",
    hideWhenPartnersDisabled: true,
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.LOGOUT,
    label: "LOGOUT",
    slug: "",
    isLogout: true,
    icon: "/assets/icons/logout.svg",
    subText: "Stay logged in for faster checkout",
  },
];

/** Inserted after primary account links on mobile hub (legacy RightMenu / geo_config). */
export const ACCOUNT_ENQUIRY_MENU_ACTIONS = {
  SHOW_CURRENCIES: "showCurrenciesList",
  SHOW_CORPORATE_GIFTS: "showCorporateGifts",
  NAVIGATE_CONTACT_US: "navigateToContactUs",
};

export const accountEnquiryMenuItems = [
  {
    id: "currency",
    icon: "/assets/icons/dollar-square.svg",
    action: ACCOUNT_ENQUIRY_MENU_ACTIONS.SHOW_CURRENCIES,
    isCurrencyLabel: true,
  },
  {
    id: "corp-gifts",
    name: "Corporate Gifts/ Bulk Orders",
    icon: "/assets/icons/building.svg",
    action: ACCOUNT_ENQUIRY_MENU_ACTIONS.SHOW_CORPORATE_GIFTS,
  },
  {
    id: "franchise",
    name: "Start An FNP Franchise",
    href: "/info/franchise-programme?promo=franchise_enquiry",
    icon: "/assets/icons/fnp-black.svg",
  },
  {
    id: "wq",
    name: "Birthday/ Wedding Decor",
    href: "/services/weddings-n-events?promo=wedding_enquiry",
    icon: "/assets/icons/Balloon1.svg",
  },
  {
    id: "pq",
    name: "Become A Vendor",
    href: "/info/become-a-partner?promo=partner_enquiry",
    icon: "/assets/icons/iconoir_shop-alt.svg",
  },
  {
    id: "contact-us",
    name: "Contact Us",
    icon: "/assets/icons/messages.svg",
    action: ACCOUNT_ENQUIRY_MENU_ACTIONS.NAVIGATE_CONTACT_US,
  },
];

/** Mobile account hub primary rows ([Figma mobile hub](https://www.figma.com/design/hMCqLuiLP7b3VQ8x2aWRl9/My-Accounts-Migration--2026?node-id=35-8121)). */
export const accountMobileHubMenuItems = [
  {
    id: ACCOUNT_MENU_ITEM_IDS.MY_ORDERS,
    label: "My orders",
    slug: AccountRoutes.MY_ORDERS,
    subText: "Track orders and download invoices",
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.FNP_CASH,
    label: "FNP Cash",
    slug: AccountRoutes.WALLET_DETAILS,
    subText: "Quick checkout, easy refunds",
    hideForSmartBuyOrCorporate: true,
    useFnpCashTitle: true,
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.MY_PROFILE,
    label: "My profile",
    slug: AccountRoutes.MY_PROFILE,
    subText: "Personal details and important dates",
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.SAVED_ADDRESSES,
    label: "Saved addresses",
    slug: AccountRoutes.MY_ADDRESS_BOOK,
    subText: "Faster checkout at your saved places",
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.GIFT_VOUCHERS,
    label: "Gift vouchers",
    slug: AccountRoutes.GIFT_VOUCHER,
    subText: "View and manage your vouchers",
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.NOTIFICATIONS,
    label: "Notification settings",
    slug: AccountRoutes.NOTIFICATION_SETTING,
    subText: "Choose how you hear from us",
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.PARTNERS,
    label: "Partners",
    slug: AccountRoutes.PARTNERS,
    subText: "Earn rewards with every FNP order!",
    hideWhenPartnersDisabled: true,
  },
  {
    id: ACCOUNT_MENU_ITEM_IDS.PRIVACY,
    label: "Privacy policy",
    href: "/info/privacy-policy",
    subText: "How we keep your information safe",
  },
  {
    id: "contact-us",
    label: "Contact Us",
    subText: "Chat with our gifting experts",
    action: ACCOUNT_ENQUIRY_MENU_ACTIONS.NAVIGATE_CONTACT_US,
  },
  {
    id: "faqs",
    label: "FAQs",
    href: "/info/faq",
    subText: "Find quick answers and support",
  },
];

/** Primary hub rows before the Enquiries block (legacy index split after partners). */
export const ACCOUNT_MOBILE_HUB_PRIMARY_IDS = [
  ACCOUNT_MENU_ITEM_IDS.FNP_CASH,
  ACCOUNT_MENU_ITEM_IDS.MY_ORDERS,
  ACCOUNT_MENU_ITEM_IDS.SAVED_ADDRESSES,
  ACCOUNT_MENU_ITEM_IDS.PRIVACY,
  ACCOUNT_MENU_ITEM_IDS.NOTIFICATIONS,
  ACCOUNT_MENU_ITEM_IDS.PARTNERS,
];

/** Desktop hub cards (legacy accountDetails). */
export const accountHubCards = [
  {
    label: "My Orders",
    id: ACCOUNT_MENU_ITEM_IDS.MY_ORDERS,
    slug: AccountRoutes.MY_ORDERS,
    icon: "/assets/icons/red-box.svg",
    subText: "Track Orders, Returns, Buy Thing Again",
  },
  {
    label: "My Profile",
    id: ACCOUNT_MENU_ITEM_IDS.MY_PROFILE,
    slug: AccountRoutes.MY_PROFILE,
    icon: "/assets/icons/profile-circle.svg",
    subText: "View/Edit Profile",
  },
  {
    label: "fnpCash",
    id: ACCOUNT_MENU_ITEM_IDS.FNP_CASH,
    slug: AccountRoutes.WALLET_DETAILS,
    icon: "/assets/icons/fnpCash_green.svg",
    subText: "Quick Checkout, Easy Refund",
    hideForSmartBuyOrCorporate: true,
  },
  {
    label: "Saved Addresses",
    id: ACCOUNT_MENU_ITEM_IDS.SAVED_ADDRESSES,
    slug: AccountRoutes.MY_ADDRESS_BOOK,
    icon: "/assets/icons/location-icon-green.svg",
    subText: "View/Edit Addresses",
  },
  {
    label: "Gift Vouchers",
    id: ACCOUNT_MENU_ITEM_IDS.GIFT_VOUCHERS,
    slug: AccountRoutes.GIFT_VOUCHER,
    icon: "/assets/icons/tag_purple.svg",
    subText: "Used/Unused Gift Vouchers",
  },
  {
    label: "Notification Settings",
    id: ACCOUNT_MENU_ITEM_IDS.NOTIFICATIONS,
    slug: AccountRoutes.NOTIFICATION_SETTING,
    icon: "/assets/icons/notification-yellow.svg",
    subText: "Manage your notification preferences",
  },
  {
    label: "Partners",
    id: ACCOUNT_MENU_ITEM_IDS.PARTNERS,
    slug: AccountRoutes.PARTNERS,
    icon: "/assets/icons/users.svg",
    subText: "Earn rewards with every FNP order!",
    hideWhenPartnersDisabled: true,
  },
];
